export default __webpack_public_path__ + "static/media/2.1401d482.png";